export enum ApiConfigurationWizardStep {
    General = 1,
    Request = 2,
    Response = 3,
    EventsList = 4,
    Event = 5,
}
